import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";

export const Wrapper = styled(Box)(() => ({
  display: "flex",
  height: "100vh",
  width: "50vw",
  alignItems: "end",
  justifyContent: "center",
  paddingRight: "120px",
  flexDirection: "column",
  gap: 8,
}));

